import {ModalComponentProps, Card, Block, Dialog, DialogBody, DialogFooter, Button, VF, Yup, makeValidate} from '@mc/ui-v4';

import {Form} from 'react-final-form';
import React from 'react';
type Props = ModalComponentProps & {onSubmit: (data: {nazev: string}) => void; isEdit?: boolean; initialValues?: {nazev: string}};

export const NewEditKategorie: React.FC<Props> = ({onClose, onSubmit, isEdit, initialValues}) => {
    const validateSchema = Yup.object().shape({});
    const validation = makeValidate(validateSchema);
    return (
        <Form
            validate={async data => {
                const errors = await validation(data);
                return errors;
            }}
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {({handleSubmit, submitting}) => {
                return (
                    <Dialog onClose={onClose} title={isEdit ? 'Upravit kategorii' : 'Nová kategorie'}>
                        <DialogBody>
                            <Card>
                                <Block>
                                    <VF.String name={'nazev'} label={'Název kategorie'} />
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                {isEdit ? 'Uložit' : 'Vytvořit'}
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
